<div class="screen">
  <div class="screen-container">
    <div class="screen-header flex-between">
      <div class="header-big">EOD Report Inputs</div>
    </div>
    <div class="screen-body">
      <div class="flex-column-center p-0">
        <div class="flex-1 overflow-auto">
          <div class="grid-2">
            <!-- Common fields across all jurisdictions -->
            <div class="form-group">
              <label for="software-detail">Software</label>
              <textarea class="form-control" [(ngModel)]="event['software']" id="software-detail" rows="3" placeholder="No Issue"></textarea>
            </div>

            <div class="form-group">
              <label for="Infrastructure-detail">Infrastructure</label>
              <textarea class="form-control" [(ngModel)]="event['infrastructure']" id="Infrastructure-detail" rows="3" placeholder="No Issue"></textarea>
            </div>

            <!-- RVC specific fields -->
            <div class="form-group" *ngIf="event['jurisdictionCode'] === 'RVC'">
              <label for="transceivers">Transceivers</label>
              <textarea class="form-control" [(ngModel)]="event['transceivers']" id="transceivers" rows="3" placeholder="No Issue"></textarea>
            </div>

            <!-- Graphics section - conditional based on jurisdiction -->
            <div class="form-group" *ngIf="['RVC', 'RSA'].includes(event['jurisdictionCode'])">
              <label for="graphics-detail">3rd Party Graphics</label>
              <textarea class="form-control" [(ngModel)]="event['graphics']" id="graphics-detail" rows="3" placeholder="No Issue"></textarea>
            </div>

            <div class="form-group" *ngIf="event['jurisdictionCode'] === 'HRV'">
              <label for="trotsvision-graphics">TrotsVision Graphics</label>
              <textarea class="form-control" [(ngModel)]="event['trotsvision_graphics']" id="trotsvision-graphics" rows="3" placeholder="No Issue"></textarea>
            </div>

            <div class="form-group" *ngIf="['BRC', 'HRQ', 'QRC', 'ATC', 'STC', 'RVC', 'RSA'].includes(event['jurisdictionCode'])">
              <label for="sky-racing-graphics">Sky Racing Graphics</label>
              <textarea class="form-control" [(ngModel)]="event['sky_racing_graphics']" id="sky-racing-graphics" rows="3" placeholder="No Issue"></textarea>
            </div>

            <!-- Starting Pulse section - conditional label -->
            <div class="form-group">
              <label for="starting-pulse-detail">
                {{['NZ', 'ARC'].includes(event['jurisdictionCode']) ? 'Starting Pulse & Timing' :
                  event['jurisdictionCode'] === 'RVC' ? 'Barrier Starting Pulse' : 'Starting Pulse'}}
              </label>
              <textarea class="form-control" [(ngModel)]="event['pulse']" id="starting-pulse-detail" rows="3" placeholder="No Issue"></textarea>
            </div>

            <!-- Tags section -->
            <div class="form-group">
              <label for="tags-detail" class="flex-between">
                <span>Tags</span>
                <span class="light-text">Race < race #>, horse < horse #>, tag < tag #>, set to DidNotTrack</span>
              </label>
              <textarea class="form-control" [(ngModel)]="event['tags']" id="tags-detail" rows="3" placeholder="No Issue"></textarea>
            </div>

            <!-- Official Reports/Results section -->
            <div class="form-group">
              <label for="race-reports-detail">
                {{event['jurisdictionCode'] === 'RVC' ? 'Official Results' : 'Official Reports'}}
              </label>
              <textarea class="form-control" [(ngModel)]="event['reports']" id="race-reports-detail" rows="3" placeholder="No Issue"></textarea>
            </div>

            <!-- Racing.com Upload -->
            <div class="form-group" *ngIf="['RVC', 'RSA'].includes(event['jurisdictionCode'])">
              <label for="website">Racing.com Upload</label>
              <textarea class="form-control" [(ngModel)]="event['website']" id="website" rows="3" placeholder="No Issue"></textarea>
            </div>

            <!-- Barrier Load Performance -->
            <div class="form-group" *ngIf="event['jurisdictionCode'] === 'RVC'">
              <label for="barrier_load_performance">Barrier Load Performance</label>
              <textarea class="form-control" [(ngModel)]="event['barrier_load_performance']" id="barrier_load_performance" rows="3" placeholder="No Issue"></textarea>
            </div>

            <!-- General Comments -->
            <div class="form-group">
              <label for="general-detail">General Comments</label>
              <textarea class="form-control" [(ngModel)]="event['general']" id="general-detail" rows="3" placeholder="No Issue"></textarea>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="screen-buttons flex-end">
      <button class="btn btn-primary-soft" (click)="hideModel.emit(true)">Submit</button>
      <button class="btn btn-light" (click)="hideModel.emit(false)">Close</button>
    </div>
  </div>
</div>
